import React, { useRef } from 'react';
import { AriaTabPanelProps, useTabPanel } from 'react-aria';
import { TabListState } from 'react-stately';
import useMergedRefs from 'hooks/useMergedRefs';
import * as S from './styles';

export interface TabPanelProps<T extends object> extends AriaTabPanelProps {
  className?: string;
  state: TabListState<T>;
}

export function ForwardedTabPanel<T extends object>(
  { className, state, ...props }: TabPanelProps<T>,
  forwardedRef: React.ForwardedRef<HTMLDivElement>,
): React.ReactElement | null {
  const tabPanelRef = useRef<HTMLDivElement>(null);
  const ref = useMergedRefs([tabPanelRef, forwardedRef]);

  const { tabPanelProps } = useTabPanel(props, state, tabPanelRef);
  return (
    <S.Root {...tabPanelProps} className={className} ref={ref}>
      {state.selectedItem?.props.children}
    </S.Root>
  );
}

export const TabPanel = React.forwardRef(ForwardedTabPanel) as <
  T extends object,
>(
  props: TabPanelProps<T> & { ref?: React.Ref<HTMLDivElement> },
) => React.ReactElement | null;

export default TabPanel;
